import { Component, Input } from '@angular/core';
import { TabsPanel } from './tabs-panel.component';

@Component({
	selector: 'tab-component',
	template: `
    <div [hidden]="!active">
      <ng-content></ng-content>
    </div>
  `
})
export class TabComponent {
	@Input() active = false;
	@Input() tabTitle: string;
	@Input() highlight: boolean;

	constructor(tabs: TabsPanel) {
		tabs.addTab(this);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/tabs-panel/tab.component.ts